export default {
  Codigo: null,
  Descripcion: '',
  Ingreso: false,
  Egreso: false,
  Transferencia: false,
  Activo: true,
};
